export const groupPostcodes = (postcodes: string[]) => {
  const groups = new Map<string, string[]>();
  for (const postcode of new Set(
    postcodes.map((value) => value.trim().toUpperCase()),
  )) {
    const area = postcode.match(/^[A-Z]+/)?.[0] ?? postcode;
    const group = groups.get(area) ?? [];
    group.push(postcode);
    groups.set(area, group);
  }

  return [...groups.entries()]
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([area, values]) => {
      const districts = values
        .filter((value) => /^[A-Z]+\d+$/.test(value))
        .map((value) => Number(value.slice(area.length)))
        .sort((left, right) => left - right);
      const ranges: string[] = [];
      for (let index = 0; index < districts.length; index++) {
        const start = districts[index]!;
        let end = start;
        while (districts[index + 1] === end + 1) {
          end = districts[++index]!;
        }
        ranges.push(
          start === end ? `${area}${start}` : `${area}${start}-${end}`,
        );
      }
      const otherPostcodes = values
        .filter((value) => !/^[A-Z]+\d+$/.test(value))
        .sort((left, right) =>
          left.localeCompare(right, "en", { numeric: true }),
        );
      return {
        area,
        postcodes: [...otherPostcodes, ...ranges].sort((left, right) =>
          left.localeCompare(right, "en", { numeric: true }),
        ),
      };
    });
};
